import React, { useRef, useState } from "react";
import { FaPalette } from "react-icons/fa";

import useDismissOnOutsideClick from "../../components/Dashboard/useDismissOnOutsideClick";

function DashboardTraceColorControl({
  t,
  mode,
  speeds,
  activeSpeedIndex,
  onModeChange,
  onSpeedSelect,
  onSpeedChange,
}) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const speedMode = mode === "speed";
  useDismissOnOutsideClick(open, rootRef, () => setOpen(false));

  return (
    <div className="map-trace-color" ref={rootRef}>
      <button
        type="button"
        className={`btn-search map-trace-toggle${
          open || speedMode ? " active" : ""
        }`}
        onClick={() => setOpen((value) => !value)}
        title={t("Cor do rastro")}
      >
        <FaPalette />
        <span className="map-trace-toggle-label">{t("Cores")}</span>
      </button>

      {open && (
        <div className="map-trace-content map-trace-color-content">
          <div className="map-trace-color-layout">
            <span className="map-trace-speed-title">
              {t("Velocidade planejada")}
            </span>
            <p className="map-trace-intro">{t("Como colorir o rastro")}</p>
            <label className="map-trace-color-option">
              <input
                type="radio"
                name="dashboard-trace-color"
                checked={!speedMode}
                onChange={() => onModeChange("machine")}
              />
              {t("Cada máquina")}
            </label>
            <label className="map-trace-color-option">
              <input
                type="radio"
                name="dashboard-trace-color"
                checked={speedMode}
                onChange={() => onModeChange("speed")}
              />
              {t("Por velocidade")}
            </label>
            {(speeds || []).map((speed, index) => (
              <label
                key={index}
                className={`map-trace-speed-choice map-trace-speed-choice--${index}${
                  index === activeSpeedIndex ? " is-active" : ""
                }`}
              >
                <input
                  type="number"
                  min="1"
                  max="120"
                  step="0.5"
                  value={speed}
                  aria-pressed={index === activeSpeedIndex}
                  title={
                    index === activeSpeedIndex
                      ? t("Velocidade em uso")
                      : t("Usar esta velocidade")
                  }
                  onFocus={() => onSpeedSelect(index)}
                  onChange={(event) => onSpeedChange(index, event.target.value)}
                />
                <span>km/h</span>
              </label>
            ))}
          </div>
          <ul className="map-trace-speed-legend">
            <li>
              <i className="is-yellow" />
              {t("Mais de 10% abaixo da velocidade planejada")}
            </li>
            <li>
              <i className="is-blue" />
              {t("Dentro da velocidade planejada")}
            </li>
            <li>
              <i className="is-red" />
              {t("Mais de 10% acima da velocidade planejada")}
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}

export default DashboardTraceColorControl;
